import { withDefault, NumberParam, BooleanParam } from 'use-query-params'

export const PageParam = withDefault(NumberParam, 0)
export const RowsPerPageParam = withDefault(NumberParam, 10)
export const ShowClosedParam = withDefault(BooleanParam, false)
